// extracted by css-extract-rspack-plugin
export default {"grid":"xSpaq","alias":"TJwmV"};